import $http from '@Config/axios'
import $store from '@Store'

const prefix = 'formulario-link'
const tipo = 'Link do formulário'
const artigo = 'o'

export default {
  index(params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/index`, params)
        .then(resolve)
        .catch(reject)
    })
  },
  show(id, params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/show/${id}`, params)
        .then(resolve)
        .catch(reject)
    })
  },
  createOrUpdate(params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/createOrUpdate`, params)
        .then(response => {
          $store.dispatch('SHOW_SNACKBAR', { message: `${tipo} salv${artigo} com sucesso!` })
          resolve(response)
        })
        .catch(reject)
    })
  },
  store(params) {
    return new Promise((resolve, reject) => {
      $http.post(prefix, params)
        .then(response => {
          $store.dispatch('SHOW_SNACKBAR', { message: `${tipo} criad${artigo} com sucesso!` })
          resolve(response)
        })
        .catch(reject)
    })
  },
  renderizarPaginaPublica(token, params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/formulario/${token}`, params)
        .then(response => {
          // $store.dispatch('SHOW_SNACKBAR', { message: `${tipo} abert${artigo} com sucesso!` })
          resolve(response)
        })
        .catch(reject)
    })
  },
  update(params) {
    return new Promise((resolve, reject) => {
      $http.put(`${prefix}/${params.id}`, params)
        .then(response => {
          $store.dispatch('SHOW_SNACKBAR', { message: `${tipo} atualizad${artigo} com sucesso!` })
          resolve(response)
        })
        .catch(reject)
    })
  },
  destroy(id) {
    return new Promise((resolve, reject) => {
      $http.delete(`${prefix}/${id}`)
        .then(response => {
          $store.dispatch('SHOW_SNACKBAR', { message: `${tipo} excluíd${artigo} com sucesso!` })
          resolve(response)
        })
        .catch(reject)
    })
  },
  restore(id) {
    return new Promise((resolve, reject) => {
      $http.patch(`${prefix}/${id}/restore`)
        .then(response => {
          $store.dispatch('SHOW_SNACKBAR', { message: `${tipo} restaurad${artigo} com sucesso!` })
          resolve(response)
        })
        .catch(reject)
    })
  }
}
